import { isValidEmail, checkPhone } from "../../common/userUtils";
import { EphemeralMember, FormErrors } from "./types";

export const validateLocation = (location: string | undefined): FormErrors => {
  const errors: FormErrors = {};
  if (location === "" || location === "null" || !location) {
    errors["location"] = "Address required.";
  }
  try {
    const locationObj = JSON.parse(location || "");
    if (!locationObj?.address) {
      errors["location"] = "Address required.";
    }
  } catch (e) {
    errors["location"] = "Invalid address.";
  }
  return errors;
};

const validateContact = (
  member: EphemeralMember,
  nameRequired: boolean = false,
): FormErrors => {
  const errors: FormErrors = {};

  // Only validate phone if nameRequired is true (since phone is now collected in SignupConfirmation)
  if (nameRequired) {
    if (!member.primaryPhone) {
      errors["primaryPhone"] = "Required";
    }
    if (!member.firstName) {
      errors["firstName"] = "Required";
    }
    if (!member.lastName) {
      errors["lastName"] = "Required";
    }
  }

  // Always validate email
  if (!member.primaryEmail) {
    errors["primaryEmail"] = "Required";
  }

  if (member.primaryPhone && !checkPhone(member.primaryPhone || "")) {
    errors["primaryPhone"] = "Invalid phone number";
  }
  if (member.primaryEmail && !isValidEmail(member.primaryEmail || "")) {
    errors["primaryEmail"] = "Invalid email address";
  }
  return errors;
};

export { validateContact };
